import "./App.css";
import React, { Component } from "react";
import axios from "axios";

class App2 extends Component {
  state = {
    profiles: [],
  };

  addNewProfile = (profileData) => {
    this.setState((prevState) => ({
      profiles: [...prevState.profiles, profileData],
    }));
  };

  render() {
    return (
      <div className="App">
        <a href="/enhanced-cards/index.js" className="enhanced-link">
          Check out the enhanced edition
        </a>
        <Form onSubmit={this.addNewProfile} />
        <GithubCards title="Github Cards" profiles={this.state.profiles} />
      </div>
    );
  }
}

class GithubCards extends Component {
  render() {
    return (
      <div>
        <div className="header">{this.props.title}</div>
        <div>
          <CardList profiles={this.props.profiles} />
        </div>
      </div>
    );
  }
}

class Card extends Component {
  render() {
    const profile = this.props;
    return (
      <div className="github-profile">
        <img className="profile-image" src={profile.avatar_url}></img>
        <div className="profile-info">
          <div className="profile-name">{profile.name}</div>
          <div className="profile-company">{profile.company}</div>
        </div>
      </div>
    );
  }
}

class Form extends Component {
  state = { username: "" };
  handleSubmit = async (event) => {
    event.preventDefault();
    const resp = await axios.get(
      `https://api.github.com/users/${this.state.username}`
    );
    this.props.onSubmit(resp.data);
    this.setState({ username: "" });
  };

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <input
          type="text"
          value={this.state.username}
          onChange={(event) => this.setState({ username: event.target.value })}
          placeholder="Github username"
        />
        <button>Add Profile</button>
      </form>
    );
  }
}

const CardList = (props) => (
  <div className="github-profile-list">
    {props.profiles.map((profile) => (
      <Card key={profile.id} {...profile} />
    ))}
  </div>
);

export default App2;
